import { render, staticRenderFns } from "./SimpleCalendar.vue?vue&type=template&id=2f477845&scoped=true&"
import script from "./SimpleCalendar.vue?vue&type=script&lang=js&"
export * from "./SimpleCalendar.vue?vue&type=script&lang=js&"
import style0 from "./SimpleCalendar.vue?vue&type=style&index=0&id=2f477845&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f477845",
  null
  
)

export default component.exports